"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./infinite-scroll.directive"));
__export(require("./infinite-scroll.module"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/ng-infinitescroll/dist/index.js
// module id = ../../../../ng-infinitescroll/dist/index.js
// module chunks = vendor